import { useEffect, useState, useMemo } from "react";
import { TableHeader, Pagination } from "../../../../components/DataTable";
import "./../invoicePDF.css";
import { Modal, Tooltip, OverlayTrigger, Button } from "react-bootstrap";

const ProcessingQuotesTable = ({
  quotes,
  getStatusColor,
  search,
  loadingQuotes,
  refreshQuotes,
  deleteQuote
}) => {
  //Archived Quotes
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState({ field: "status", order: "desc" });
  const [quotedItem, setQuotedItem] = useState(null);
  const [showModal2, setShowModal2] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0)
  const ITEMS_PER_PAGE = 20;
  const [previewImage, setPreviewImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const columnWidths = ["10%", "60%", "15%", "15%"];

  const processingHeaders = [
    { name: "No#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Qty", field: "qty", sortable: true },
    { name: "Image", field: "img", sortable: true },
    { name: "Status", field: "status", sortable: true },
    { name: "Submitted Date", field: "submittedAt", sortable: true },
    { name: "", field: "delete", sortable: false },

  ];

  const quoteItems = useMemo(() => {
    let computedQuotes = quotes;

    if (search) {
      computedQuotes = computedQuotes?.filter(
        (quotes) =>
          quotes.submittedAt?.toUpperCase().includes(search.toUpperCase()) ||
          quotes.ctlsku?.toUpperCase().includes(search.toUpperCase()) ||
          quotes.name?.toUpperCase().includes(search.toUpperCase()) ||
          quotes.product?.name?.toUpperCase().includes(search.toUpperCase()) ||
          ""
      );
      setCurrentPage(1);
    }

    setTotalItems(computedQuotes?.length);

    //Sorting products
    const getNestedProperty = (obj, path) => {
      return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    };

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedQuotes = computedQuotes.sort((a, b) => {
        const fieldA = getNestedProperty(a, sorting.field);
        const fieldB = getNestedProperty(b, sorting.field);
        if (typeof fieldA === "number" && typeof fieldB === "number") {
          return reversed * (fieldA - fieldB);
        } else if (typeof fieldA === "string" && typeof fieldB === "string") {
          return reversed * fieldA.localeCompare(fieldB);
        } else {
          // If field types are different, compare their string representations
          return reversed * String(fieldA).localeCompare(String(fieldB));
        }
      });
    }

    // Default sort by submittedAt / createdAt DESC
    computedQuotes = [...computedQuotes].sort((a, b) => {
      const dateA = new Date(a.submittedAt || a.createdAt || 0);
      const dateB = new Date(b.submittedAt || b.createdAt || 0);

      return dateB - dateA;
    });
    return {
      processingQuotes: computedQuotes?.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      ),
    };
  }, [quotes, currentPage, search, sorting]);

  const deleteHandler = async (quoteId) => {
    if (window.confirm("Are you sure?")) {
      deleteQuote(quoteId).then(() => {
        refreshQuotes();
      });
    }
  };

  const toggleModal2 = (quoteItem) => {
    if (!showModal2) {
      setShowModal2(true);
      setQuotedItem(quoteItem)
      calculateTotal(quoteItem)
    } else {
      setShowModal2(false);
    }
  };

  const calculateTotal = (quoteItem) => {
    let total = 0
    quoteItem?.items?.map((item) => {
      total = total + item.totalPrice
    })
    setTotalAmount(total)
  }

  const handleClose = () => {
    setShowModal2(false)
  };

  return (
    <>
      <table className="table table-striped">
        <TableHeader
          headers={processingHeaders}
          onSorting={(field, order) => setSorting({ field, order })}
          widths={columnWidths}
        />
        <tbody>
          {quoteItems.processingQuotes?.map((quoteItem, idx) => (
            <tr key={"processingQuotes" + idx}
              onClick={() => quoteItem?.items?.length > 1 ? toggleModal2(quoteItem) : null}
              style={quoteItem?.items?.length > 1 ? { cursor: "pointer" } : null}>
              <td>{idx + 1} </td>
              <td>
                {/* {quoteItem.product ? quoteItem.product.name : quoteItem.name} */}
                {
                  quoteItem?.items?.length > 1
                    ? `Multiple Items (${quoteItem.items.length})`
                    : quoteItem?.items?.length === 1
                      ? quoteItem.items[0]?.productName
                      : quoteItem?.product
                        ? quoteItem.product.name
                        : quoteItem?.name
                }
              </td>
              <td>{quoteItem.quantity}</td>
              <td >
                {quoteItem.clientImages.length === 1 ? (
                  <img
                    src={quoteItem.clientImages[0]?.path}
                    alt="quote"
                    onClick={() => {
                      setPreviewImage(quoteItem.clientImages[0]?.path);
                      setShowImageModal(true);
                    }}
                    style={{
                      width: "55px",
                      height: "55px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      cursor: "pointer"
                    }}
                  />
                ) : (
                  <span>No / Multiple Images</span>
                )}
              </td>
              <td
                style={{
                  color: getStatusColor(quoteItem.status),
                  fontWeight: "bold",
                }}
              >
                {quoteItem.status}
              </td>
              <td>{quoteItem.submittedAt?.substring(0, 10)}</td>
              <td>
                <button
                  variant="danger"
                  className="btn-sm btn-light"
                  onClick={() => deleteHandler(quoteItem._id)}
                  style={{ border: "none" }}
                >
                  <i className="bi bi-x-circle"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {quotes.length === 0 && (
        <div className="fs-3 m-2">No Quotes Found</div>
      )}

      <Pagination
        total={totalItems}
        itemsPerPage={ITEMS_PER_PAGE}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />

      <Modal
        show={showModal2}
        onHide={handleClose}
        className="preview_quote_product_modal2">
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "center", width: "100%" }}>
            {quotedItem?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "left" }}>
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Product</th>
                <th>CTL SKU</th>
                <th>Qty</th>
                <td>Image</td>
                <th>Unit Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              {quotedItem?.items?.map((item, index) => (
                <>
                  <tr key={item._id || index}>
                    <td>{index + 1}</td>
                    <td>
                      {item.product?.name || item.productName}
                    </td>
                    <td>{item.ctlsku}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {quotedItem?.clientImages ? (
                        < img
                          src={quotedItem?.clientImages[index]?.path}
                          alt="quote"
                          onClick={() => {
                            setPreviewImage(quotedItem?.clientImages[index]?.path);
                            setShowImageModal(true);
                          }}

                          style={{
                            width: "55px",
                            height: "55px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            cursor: "pointer"
                          }}
                        />
                      ) : (
                        <span>No Image</span>
                      )}
                    </td>
                    <td>
                      {
                        `$${item.unitPrice.toFixed(2) || 0}`
                      }
                    </td>
                    <td>
                      {
                        `$${item.totalPrice.toFixed(2) || 0}`
                      }
                    </td>
                  </tr>
                </>

              ))}
            </tbody>
          </table>
          <h6 style={{ textAlign: "right", marginRight: "4%" }}>
            Total:{" "}
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              {totalAmount.toFixed(2)}
            </span>
          </h6>
          <h6>
            Satus:{" "}
            <span
              style={{
                fontWeight: "bold",
                color: "green"
              }}
            >
              {quotedItem?.status ? quotedItem.status : null}
            </span>
          </h6>
          <h6>
            Action:{" "}
            <span
              style={{
                fontWeight: "bold",
                color:
                  quotedItem?.accepted === true
                    ? "green"
                    : quotedItem?.accepted === false
                      ? "red"
                      : "orange",
              }}
            >
              {quotedItem?.accepted === true
                ? "Accepted"
                : quotedItem?.accepted === false
                  ? "Declined"
                  : "Waiting"}
            </span>
          </h6 >
        </Modal.Body>
      </Modal >

      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="xl"
      >
        <Modal.Body
          style={{
            textAlign: "center",
            background: "#ffffff",
          }}
        >
          <img
            src={previewImage}
            alt="preview"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProcessingQuotesTable;
